<template>
  <SettingsForm />
</template>
<script>
import SettingsForm from "./Form";
import store from "@/store/index";
export default {
  components: {
    SettingsForm,
  },
  beforeRouteEnter(to, from, next) {
    let getSettings = store.dispatch("settings/GET_SETTINGS");

    Promise.all([getSettings]).then(() => {
      next();
    });
  },
};
</script>
